export default __webpack_public_path__ + "static/media/732 1.e71cb469.jpg";